import { StatusConfig } from '@shared/status';
import { FeedbackStatus } from '@root/pages/feedback';

export const FEEDBACK_STATUS_CONFIG: StatusConfig<FeedbackStatus> = {
  [FeedbackStatus.New]: {
    color: 'var(--feedback-status-new-border-color)',
    borderColor: 'var(--feedback-status-new-border-color)',
    backgroundColor: 'var(--feedback-status-new-background-color)',
  },
  [FeedbackStatus.InProgress]: {
    color: 'var(--feedback-status-in_progress-border-color)',
    borderColor: 'var(--feedback-status-in_progress-border-color)',
    backgroundColor: 'var(--feedback-status-in_progress-background-color)',
  },
  [FeedbackStatus.Processed]: {
    color: 'var(--feedback-status-processed-border-color)',
    borderColor: 'var(--feedback-status-processed-border-color)',
    backgroundColor: 'var(--feedback-status-processed-background-color)',
  },
};
